import { render, staticRenderFns } from "./ActivityMessageSingleCol.vue?vue&type=template&id=3bf34110&scoped=true"
import script from "./ActivityMessageSingleCol.vue?vue&type=script&lang=ts"
export * from "./ActivityMessageSingleCol.vue?vue&type=script&lang=ts"
import style0 from "./ActivityMessageSingleCol.vue?vue&type=style&index=0&id=3bf34110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf34110",
  null
  
)

export default component.exports